export default "__VITE_ASSET__BSlQM3bu__"